

export const getConnectedThingsFrom = function(uuid, flow) {
    if (flow.Return) {
        return getConnectedThingsFrom(uuid, flow.Return);
    }
    if (flow.UUID === uuid) {
        return flow || [];
    }
    if (!flow.ConnectedThings || flow.ConnectedThings.length === 0) {
        return;
    }
    for (let thing of flow.ConnectedThings) {
        let res = getConnectedThingsFrom(uuid, thing);
        if (res)
            return res;
    }
    return;
}

export const generateHighlightPaths = function(flatflow, flow, config) {
    flow = typeof flow === "string" ? config.data.Flows.find(fl => fl.UUID === flow) : flow;
    let result = {
        Suction: generateHighlightPath([[]], flatflow.Suction, flow.Suction, config, flow),
        Return: generateHighlightPath([[]], flatflow.Return, flow.Return, config, flow)
    };

    return result;
}

export const generateHighlightPath = function(result, flatflow, tree, config, flow) {
    if (!tree)
        return result;
    let connections = tree.ConnectedThings;
    if (!connections || connections.length === 0) {
        let entity = config.data.Devices.find(dev => dev.UUID === tree.UUID);
        if (entity && entity.ConnectTo) {
            let connectedTo = getConnectedThingsFrom(entity.ConnectTo, flow);
            if (connectedTo) {
                connections = [connectedTo];
            }
        }
    }
    let procDown = (line, childKey) => {
        let downPath = generateHighlightPath(line, flatflow, connections[childKey], config, flow);
        if (downPath.length > 1) {
            result = result.concat(downPath.slice(1));
        }
    }

    result[0].push(tree.UUID);
    let flatState = flatflow.find(fi => fi.UUID === tree.UUID);
    if (flatState) {
        if (flatState.Position === "MIDDLE") { // water flows to both children
            let pathSoFar = [ ...result[0] ] // copy the existing sequence
            result.push(pathSoFar);
            for (let key in connections) {
                procDown([ result[key] ], key);
            }
        } else {
            let forwardKey = (flatState.Position === 'ALL_RIGHT' || flatState.Position === 'RIGHT') ? 1 : 0;
            if (connections && connections[forwardKey]) {
                procDown(result, forwardKey);
            }
        }
    }

    return result;
}

export default {
    generateHighlightPaths
}